import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServerResponse } from '../../interfaces/base/server.response';
import { Subject } from 'rxjs';
import { WasteCalendarService } from '../../services/reports/waste-calendar.service';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { AuthenticationService } from '../../services/base/authentication.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LocalStorageService } from '../../services/base/local-storage.service';

@Component({
  selector: 'fury-survey',
  templateUrl: './waste-calendar.component.html',
  styleUrls: ['./waste-calendar.component.scss'],
  animations: [fadeInUpAnimation],
})
export class WasteCalendarComponent implements OnInit, OnDestroy {

  protected readonly Object = Object;

  public isLoading: boolean = null;

  public form = this.fb.group({
    postal_code: new FormControl(null, Validators.required),
    house_number: new FormControl(null, Validators.required),
    house_letter: null,
  });

  public wasteCalendarFirst: string = null;
  public wasteCalendarData: any = null;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private fb: FormBuilder,
              private localStorageService: LocalStorageService,
              public authenticationService: AuthenticationService,
              public wasteCalendarService: WasteCalendarService,
  ) {
  }

  ngOnInit(): void {
    const data = this.localStorageService.get('afvalkalender');
    if (data !== null) {
      if (typeof data.postal_code !== 'undefined') {
        this.form.controls.postal_code.setValue(data.postal_code);
      }
      if (typeof data.house_number !== 'undefined') {
        this.form.controls.house_number.setValue(data.house_number);
      }
      if (typeof data.house_letter !== 'undefined') {
        this.form.controls.house_letter.setValue(data.house_letter);
      }
    }

    if (this.form.valid) {
      this.getData();
    }
  }

  getData(): void {
    this.isLoading = true;

    this.localStorageService.set('afvalkalender', {
      postal_code: this.form.controls.postal_code.value,
      house_number: this.form.controls.house_number.value,
      house_letter: this.form.controls.house_letter.value,
    });

    this.wasteCalendarService.get(this.form.value).subscribe(
      (response: any): void => {
        if (typeof response !== 'undefined' && typeof response.collections !== 'undefined') {
          this.wasteCalendarData = Object.entries(response.collections).map(([year, months]) => ({
            year,
            months: Object.entries(months).map(([month, pickups]) => ({
              month,
              pickups
            }))
          }));
          this.wasteCalendarFirst = response.first;
        }
        this.isLoading = false;
      }
    );
  }

  clearAddress(): void {
    this.form.reset();
    this.wasteCalendarData = null;
    this.wasteCalendarFirst = null;
  }

  print(): void {
    if (this.isIOs()) {
      alert('Gebruik het deelmenu van Safari en kies "Print" om af te drukken.');
      return;
    }

    window.print();
  }

  private isIOs(): boolean {
    return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
  }

  trackByYear(index: number, item: { year: string; months: any[] }): string {
    return item.year;
  }

  trackByMonth(index: number, item: { month: string; pickups: any[] }): string {
    return item.month;
  }

  trackByPickup(index: number, item: any): string | number {
    return item.date ? `${item.date.day_text}-${item.date.day}` : index;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
